// Stock ambient clinic videos (Pexels, verified direct mp4) used as defaults.
// Every one is replaceable from the backoffice: Settings -> Page Videos (Liquid Luxury).
export const STOCK_VIDEOS = {
  home: "https://videos.pexels.com/video-files/1918465/1918465-hd_1920_1080_24fps.mp4",
  treatments: "https://videos.pexels.com/video-files/4496268/4496268-hd_1920_1080_25fps.mp4",
  doctors: "https://videos.pexels.com/video-files/5069213/5069213-hd_1920_1080_30fps.mp4",
  about: "https://videos.pexels.com/video-files/3209211/3209211-hd_1920_1080_25fps.mp4",
  gallery: "https://videos.pexels.com/video-files/5752729/5752729-hd_1920_1080_30fps.mp4",
  blog: "https://videos.pexels.com/video-files/5309381/5309381-hd_1920_1080_25fps.mp4",
  contact: "https://videos.pexels.com/video-files/7017797/7017797-hd_1920_1080_30fps.mp4",
};

// Resolve the video for a page: backoffice override wins, stock default otherwise.
// Pass a falsy fallback to disable video when the admin clears the field with "off".
export const pageVideo = (settings, key) => {
  const v = settings?.[`video_${key}`];
  if (v === "off") return null;
  return v || STOCK_VIDEOS[key];
};
